module.exports = __webpack_public_path__ + "media/images/favicons/favicon-monday-16x16-67049492c4d25119cd9f7bf65ceaa7be.png";